module.exports = __webpack_public_path__ + "img/woo.b3dbad1a.svg";